import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useClasses } from '../../../utils/overrides';
import { createUseStyles } from '../../../utils/styles';
import styles from './messageStyles';
const useStyles = createUseStyles(styles, 'ToastMessage');
function ToastMessage(_ref) {
  let {
    classes: classesProp,
    title,
    text,
    type = 'info'
  } = _ref;
  const classes = useClasses(useStyles, classesProp);
  const rootProps = {
    className: classes.root
  };
  const titleProps = {
    className: classnames(classes.title, {
      [classes[type]]: true
    })
  };
  return /*#__PURE__*/React.createElement("div", rootProps, title && title.length > 0 && /*#__PURE__*/React.createElement("span", titleProps, title), /*#__PURE__*/React.createElement("span", {
    className: classes.message
  }, text));
}
process.env.NODE_ENV !== "production" ? ToastMessage.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  type: PropTypes.oneOf(['info', 'success', 'error', 'warning'])
} : void 0;
export default /*#__PURE__*/React.memo(ToastMessage);